import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-product-detail-mode-toggle',
  templateUrl: './product-detail-mode-toggle.component.html',
  styleUrls: ['./product-detail-mode-toggle.component.scss'],
})
export class ProductDetailModeToggleComponent {
  readonly CUSTOMER_PAGE_INDEX = 1;
  readonly SELLER_PAGE_INDEX = 2;

  @Input() pageIndex = 1;
  @Input() isMobile: boolean;
  @Output() selectionChanged = new EventEmitter<number>();

  constructor() {}

  setSelectedSegment(event: any) {
    if (event) {
      const targetPageIndex = Number(event?.detail?.value);
      if (this.pageIndex !== targetPageIndex) {
        this.pageIndex = targetPageIndex;
        this.selectionChanged.emit(targetPageIndex);
      }
    }
  }
}
